import { Component } from 'react';

import { Grid, Box } from '@mui/material';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';
import { Route, Routes } from 'react-router-dom';
import { flowRight as compose } from 'lodash';

import AssignmentBreakdown from '../../../components/AssignmentBreakdown';
import AssignmentDetailMap from './AssignmentDetailMap';
import ShipmentDetail from './ShipmentDetail';
import styles from './styles';

class ShipmentDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messengers: [],
      topicLoading: false,
      triggerMsgLoading: false,
      newTopic: false,
      creatingTopic: false,
      assignmentLoading: false,
      _isShowMessenger: false,
      showAddingShipmentDetail: false,
    };
  }

  onShowMessenger = () => {
    const { messengerStore, assignmentStore, userStore } = this.props;
    const { selectedAssignmentId, selectedAssignment } = assignmentStore;
    if (!this.state._isShowMessenger) {
      // Allow open topic when assign to driver
      this.setState({
        topicLoading: true,
        assignmentLoading: true,
      });
      messengerStore.loadTopicByAssignmentId(selectedAssignmentId, (res) => {
        if (res.status === 200) {
          if (userStore.user && messengerStore.topicSelected && messengerStore.topicSelected.follower_ids.indexOf(userStore.user.id) !== -1) {
            this.props.messengerStore.isFollow = true;
          } else {
            this.props.messengerStore.isFollow = false;
          }
          this.setState({
            topicLoading: false,
            assignmentLoading: false,
          });
        } else if (res.status === 404) {
          this.setState({
            newTopic: true,
            topicLoading: false,
            assignmentLoading: false,
          });
        }
      });
    } else {
      messengerStore.topicSelected = null;
      messengerStore.topicSelectedId = null;
    }
    this.setState({ _isShowMessenger: !this.state._isShowMessenger });
  };

  render() {
    const { store } = this.props;
    const { assignmentStore, shipmentStore } = store;
    const { selectedStop, previewShipment } = shipmentStore;
    const { selectedAssignment } = assignmentStore;
    const _isActiveAssignmentSelected = selectedAssignment?.assignment && selectedAssignment.assignment.is_active;

    return (
      <Box sx={styles.container}>
        <Grid container direction="column" sx={styles.gridContainer}>
          <Grid sx={{ ...styles.assignmentDetailMap, height: selectedStop ? 225 : 'calc(100% - 400px)' }}>
            <AssignmentDetailMap
              previewShipment={previewShipment}
              assignment={selectedAssignment}
              locations={selectedAssignment ? selectedAssignment.locations : null}
              driverLocation={selectedAssignment ? selectedAssignment.driverLocation : null}
              shipment={selectedStop ? selectedStop.shipment : null}
            />
          </Grid>
          <Grid size="grow" sx={styles.shipmentDetail}>
            {/*<ShipmentMessenger*/}
            {/*  history={this.props.history}*/}
            {/*  topicLoading={this.state.topicLoading}*/}
            {/*  triggerMsgLoading={this.state.triggerMsgLoading}*/}
            {/*  activeAssignment={_isActiveAssignmentSelected}*/}
            {/*  assignmentLoading={this.state.assignmentLoading}*/}
            {/*/>*/}
            <Routes>
              <Route path="stops/:stopId" element={<ShipmentDetail />} />
            </Routes>
            {!selectedStop && (
              <AssignmentBreakdown selectedAssignment={assignmentStore.selectedAssignment} filteredStops={assignmentStore.filteredShowingStops} />
            )}
          </Grid>
        </Grid>
      </Box>
    );
  }
}

export default compose(
  withRouter,
  inject('store', 'messengerStore', 'userStore', 'assignmentStore'),
  observer,
)(ShipmentDetailContainer);
